import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

export const SignUpContext = React.createContext();

export const SignUpContextProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [isCreated, setIsCreated] = useState(false);

  return (
    <SignUpContext.Provider
      value={{
        userData,
        setUserData,
        isCreated,
        setIsCreated
      }}
    >
      {children}
    </SignUpContext.Provider>
  );
};

SignUpContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export const useSignUpContext = () => {
  const { userData, setUserData, isCreated, setIsCreated } = useContext(SignUpContext);

  return {
    userData,
    setUserData,
    isCreated,
    setIsCreated
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useSignUpContext.js